import Icon from '@/components/ui/AppIcon';
import AppImage from '@/components/ui/AppImage';

interface Testimonial {
  id: string;
  quote: string;
  name: string;
  title: string;
  company: string;
  avatar: string;
  avatarAlt: string;
  rating: number;
}

const testimonials: Testimonial[] = [
{
  id: 'test_1',
  quote: 'Spart uns 5 Stunden pro Woche. Keine verpassten Logins mehr, kein Warten auf SMS-Codes. Einfach perfekt für unser Team.',
  name: 'Dr. Michael Weber',
  title: 'CFO',
  company: 'TechVision GmbH',
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_19275a6a4-1763296371677.png",
  avatarAlt: 'Male CFO in business suit with glasses smiling professionally',
  rating: 5
},
{
  id: 'test_2',
  quote: 'Als IT-Leiter schätze ich die Sicherheitsstandards. ISO-Zertifizierung, DSGVO-Konformität – alles da. Endlich eine professionelle Lösung.',
  name: 'Sandra Müller',
  title: 'IT-Direktorin',
  company: 'FinanzPlus AG',
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1b4ba176d-1763299448537.png",
  avatarAlt: 'Female IT director with short hair in professional attire',
  rating: 5
},
{
  id: 'test_3',
  quote: 'Endlich unabhängig vom Handy. Ich kann meinem Team Zugriff geben, ohne Passwörter zu teilen. Die Audit-Protokolle sind Gold wert.',
  name: 'Thomas Schneider',
  title: 'Geschäftsführer',
  company: 'Schneider Consulting',
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1e3618bfa-1763301840106.png",
  avatarAlt: 'Male CEO in business casual with confident expression',
  rating: 5
}];


export default function TestimonialsSection() {
  return (
    <section className="py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center max-w-2xl mx-auto mb-16 reveal">
          <h2 className="font-serif text-3xl md:text-4xl text-foreground tracking-tight mb-4">
            Was unsere Kunden sagen
          </h2>
          <p className="text-muted-foreground font-light">
            Geschäftsführer und Manager vertrauen auf 2FA-Killer
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) =>
          <div
            key={testimonial.id}
            className={`bg-white p-8 rounded-2xl shadow-sm border border-slate-200 flex flex-col justify-between hover:shadow-lg transition-shadow duration-300 reveal delay-${(index + 1) * 100}`}>
            
              {/* Content */}
              <div>
                {/* Star Rating */}
                <div className="flex text-amber-500 mb-4 gap-0.5">
                  {[...Array(testimonial.rating)].map((_, i) =>
                <Icon key={`star_${testimonial.id}_${i}`} name="StarIcon" size={16} variant="solid" className="text-amber-500" />
                )}
                </div>

                {/* Quote */}
                <p className="text-foreground italic leading-relaxed mb-6">
                  "{testimonial.quote}"
                </p>
              </div>

              {/* Author Info */}
              <div className="flex items-center gap-3 mt-auto pt-6 border-t border-slate-100">
                <AppImage
                src={testimonial.avatar}
                alt={testimonial.avatarAlt}
                className="w-12 h-12 rounded-full object-cover" />
              
                <div>
                  <p className="text-sm font-semibold text-foreground">{testimonial.name}</p>
                  <p className="text-xs text-muted-foreground">{testimonial.title}</p>
                  <p className="text-xs text-primary font-medium">{testimonial.company}</p>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Company Logos (Generic) */}
        <div className="mt-16 reveal delay-400">
          <p className="text-center text-sm text-muted-foreground mb-8 uppercase tracking-wider">
            Vertraut von führenden Unternehmen
          </p>
          <div className="flex flex-wrap justify-center items-center gap-12 opacity-50">
            {/* Generic company placeholder logos */}
            <div className="text-slate-400 font-bold text-xl">TechVision</div>
            <div className="text-slate-400 font-bold text-xl">FinanzPlus</div>
            <div className="text-slate-400 font-bold text-xl">Schneider</div>
            <div className="text-slate-400 font-bold text-xl">DigiWorks</div>
            <div className="text-slate-400 font-bold text-xl">InnovateCo</div>
          </div>
        </div>
      </div>
    </section>);

}